export default {

  //本地
  // domainPath: 'http://localhost:8087',
  domainPath: 'https://point.haier.net/api',  // 生产环境
  // upload:"http://139.217.223.19:8094",
  // domainPath: 'https://tpoint.haier.net/api',  // 测试环境
  // domainPath: 'http://172.18.55.61:8081/api',

  serviceUrl:"https://holcc.haier.net/#/zhijiaHome?yBkTy=history&"  //客服地址
  // serviceUrl:"https://sip189.rrslexin.com/#/zhijiaHome?yBkTy=history&"  //测试客服地址
};
